import { defineComponent as _defineComponent } from 'vue'
import { ref, useTemplateRef, watch, computed } from 'vue';
    import * as z from "zod";
    import { user_change_password } from '../../module/users/module';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'change_password',
  props: ['user', 'open'],
  emits: ['save_user', 'cancel_edit'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

    let props = __props
    let emit = __emit

    const ref_dialog = useTemplateRef('dialog')

    let dat_loading = ref(false)
    let dat_old_password = ref("")
    let dat_old_password_error = ref("")
    let dat_new_password = ref("")
    let dat_new_password_error = ref("")
    let dat_repeat_new_password = ref("")
    let dat_repeat_new_password_error = ref("")

    let change_password_schema = z.object({
        old_password: z.string().min(1, "Old password is required"),
        new_password: z.string().min(1, "New Password is required"),
        repeat_new_password: z.string(),
    })
    .refine((data) => data.new_password === data.repeat_new_password, {
        message: "Passwords do not match",
        path: ["repeat_new_password"],
    });

    function cleanErrors (error: z.ZodError, field: string) {
        const loc_errors = error.issues
            .filter((tmp_issue) => {
                return tmp_issue.path.includes(field)
            })
            .map((tmp_issue) => {
                return tmp_issue.message
            })
        
        if (loc_errors.length > 0) {
            return loc_errors.join(', ')
        } else {
            return ""
        }
    }

    let com_open = computed(() => {
        return props.open
    })

    watch(com_open, () => {
        const loc_dialog: HTMLDialogElement | null = ref_dialog.value

        if (loc_dialog === null) {
            return
        }

        loc_dialog.showModal()
    })

    const reset_component = function() {
        dat_old_password.value = ""
        dat_old_password_error.value = ""
        dat_new_password.value = ""
        dat_new_password_error.value = ""
        dat_repeat_new_password.value = ""
        dat_repeat_new_password_error.value = ""
        dat_loading.value = false
    }

    const change_password = async function(old_password: string, new_password: string, repeat_new_password: string) {
        const loc_dialog: HTMLDialogElement | null = ref_dialog.value
    
        if (loc_dialog === null) {
            return
        }

        const result = change_password_schema.safeParse({ old_password, new_password, repeat_new_password});
        if (!result.success) {
            dat_old_password_error.value = cleanErrors(result.error, "old_password")
            dat_new_password_error.value = cleanErrors(result.error, "new_password")
            dat_repeat_new_password_error.value = cleanErrors(result.error, "repeat_new_password")
            return
        } else {
            dat_loading.value = true
            const response = await user_change_password(old_password, new_password)
            if (typeof response === "boolean"
                && response === true 
            ) {
                reset_component()
                loc_dialog.close()
            } else if (typeof response === "string") {
                dat_old_password_error.value = "" + response
                dat_loading.value = false
            }
        }

    }

    const cancel = function () {
        reset_component()

        const loc_dialog: HTMLDialogElement | null = ref_dialog.value
        
        if (loc_dialog === null) {
            return
        }

        loc_dialog.close()
    }


const __returned__ = { get props() { return props }, set props(v) { props = v }, get emit() { return emit }, set emit(v) { emit = v }, ref_dialog, get dat_loading() { return dat_loading }, set dat_loading(v) { dat_loading = v }, get dat_old_password() { return dat_old_password }, set dat_old_password(v) { dat_old_password = v }, get dat_old_password_error() { return dat_old_password_error }, set dat_old_password_error(v) { dat_old_password_error = v }, get dat_new_password() { return dat_new_password }, set dat_new_password(v) { dat_new_password = v }, get dat_new_password_error() { return dat_new_password_error }, set dat_new_password_error(v) { dat_new_password_error = v }, get dat_repeat_new_password() { return dat_repeat_new_password }, set dat_repeat_new_password(v) { dat_repeat_new_password = v }, get dat_repeat_new_password_error() { return dat_repeat_new_password_error }, set dat_repeat_new_password_error(v) { dat_repeat_new_password_error = v }, get change_password_schema() { return change_password_schema }, set change_password_schema(v) { change_password_schema = v }, cleanErrors, get com_open() { return com_open }, set com_open(v) { com_open = v }, reset_component, change_password, cancel }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})